<script>
    import ReadOnly from './ReadOnly.svelte';

    export let label;
    export let value;
    export let trueLabel = 'Yes';
    export let falseLabel = 'No';

    $: formattedValue = value ? trueLabel : falseLabel;
</script>

<ReadOnly label={label} value={formattedValue} />
